export default __webpack_public_path__ + "static/img-nhs-kortical-658cc831f76553b8cd82c43c66dd1202.webp";